/* @flow */
import {
  FETCH_THREAT_ACTOR,
  SAVE_THREAT_ACTOR,
  DELETE_THREAT_ACTOR,
  UPDATE_PAGE_FILTERS,
  RESET_PAGE_FILTERS,
} from './action-types.js';

import * as Types from './types';

/* Fetches all Threat Actor terms */
export const fetchAllThreatActors = (): Object => ({ type: FETCH_THREAT_ACTOR });

/* Handles save new term and edit term */
export const saveThreatActor = (threatActor: Types.ThreatActorRecordType): Object => ({
  type: SAVE_THREAT_ACTOR,
  payload: threatActor,
});

/* Delete by guid */
export const deleteThreatActor = (threatActor: Types.ThreatActorRecordType): Object => ({
  type: DELETE_THREAT_ACTOR,
  payload: threatActor,
});

export const updateFilters = (payload: Object, field?: string) => ({
  type: UPDATE_PAGE_FILTERS,
  payload,
  field,
});

export const resetFilters = () => ({ type: RESET_PAGE_FILTERS });



// WEBPACK FOOTER //
// ./src/app/modules/threat-actors/actions.js